import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Spinner from 'components/spinner/Spinner';
import Tooltip from 'components/Tooltip';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./realm-outfit-image-upload-placeholder.i18n.json'));

import './realm-outfit-image-upload-placeholder.scss';

type ModeType = 'create' | 'uploading' | 'drop';

type Props = {
  type: 'outfit' | 'profile',
  mode: ModeType,
  tooltip?: string
};

class RealmOutfitImageUploadPlaceholder extends React.PureComponent<Props> {
  static defaultProps = {
    type: 'outfit'
  };

  renderContent(mode: ModeType): React.ReactNode {
    let content: React.ReactNode = null;

    switch (mode) {
      case 'create':
        content = (
          <SVGDynamicIcon
            name="plus-inside-circle-custom-bg"
            width={25}
            height={25}
            customColor="grey-light"
          />
        );
        break;
      case 'uploading':
        content = (
          <Spinner
            position="inline"
            size="small"
            color="light"
          />
        );
        break;
      case 'drop':
        content = __t('realm_outfit_image_upload_placeholder.button_drop_here');
        break;
      default:
        break;
    }

    return content;
  }

  render(): React.ReactNode {
    const { mode, type, tooltip } = this.props;
    const classes = classnames({
      'realm-outfit-image-upload-placeholder': true,
      [`realm-outfit-image-upload-placeholder--type-${type}`]: true,
      [`realm-outfit-image-upload-placeholder--mode-${mode}`]: mode
    });

    const component = (
      <section className={classes}>
        {this.renderContent(mode)}
      </section>
    );

    if (mode === 'create') {
      return tooltip ? (
        <Tooltip
          message={tooltip}
          width="long"
        >
          {component}
        </Tooltip>
      ) : component;
    }

    return component;
  }
}

export default RealmOutfitImageUploadPlaceholder;
